import React, { useState } from 'react';
import PageDetails from '../PageDetails/PageDetails'
import TabFirst from '../TabFirst/TabFirst'


const tabsList = [
  {tabId: 'SOCIAL', displayText: 'Inspection'},
  {tabId: 'GAMES', displayText: 'Machine'},
  {tabId: 'NEWS', displayText: 'Workspace & Quality'},
  {tabId: 'FOOD', displayText: 'Inspection Tool'},
]

const appsList = [
  {
    appId: 0,
    appName: 'Facebook',
    imageUrl:
      'https://assets.ccbp.in/frontend/react-js/app-store/social-facebook.png',
    category: 'SOCIAL',
    categoryDetails:[
      {
        InspectionItem: "Filter Condition",
        Description:"Check for any tears, holes, or damage to the filter material.",
        ActionRequired: "Replace if damaged or excessively dirty.",
      },
      {
        InspectionItem: "Dirt Accumulation",
        Description:"Assess the amount of dirt and debris trapped in the filter.",
        ActionRequired: "Clean or replace if heavily soiled.",
      },
      {
        InspectionItem: "Filter Housing",
        Description:"Inspect the housing for any cracks, leaks, or misalignment.",
        ActionRequired: "Repair or replace if necessary.",
      },
      {
        InspectionItem: "Seal Integrity",
        Description:"Ensure that the seal between the filter and housing is intact and secure.",
        ActionRequired: "Replace seal if damaged or leaking.",
      },
      {
        InspectionItem: "Airflow Restriction",
        Description:"Measure airflow through the filter using appropriate tools.",
        ActionRequired: "Clean or replace if airflow is restricted.",
      },
      {
        InspectionItem: "Installation",
        Description:"Verify proper installation of the filter according to manufacturer's instructions.",
        ActionRequired: "Reinstall correctly if necessary.",
      },
      {
        InspectionItem: "Filter Compatibility",
        Description:"Confirm that the filter is the correct type and size for the specific bike model.",
        ActionRequired: "Replace with appropriate filter if needed.",
      },
      {
        InspectionItem: "Installation",
        Description:"Verify proper installation of the filter according to manufacturer's instructions.",
        ActionRequired: "Reinstall correctly if necessary.",
      },

      {
        InspectionItem: "Maintenance History",
        Description:"Review previous maintenance records to determine when the filter was last inspected or replaced.",
        ActionRequired: "Schedule replacement or cleaning accordingly.",
      }
    ]
  },
  
  {
    appId: 2,
    appName: 'Subway Surfers',
    imageUrl:
      'https://www.kanwalenterprises.com/public/images/products/img-automotive-filter-manufacturing-machines.jpg',
    category: 'GAMES',
    
  },

  
  {
    appId: 4,
    appName: 'Inshorts',
    imageUrl:
      'https://assets.ccbp.in/frontend/react-js/app-store/news-inshorts.png',
    category: 'NEWS',
    heading:'Fuel Strainer',
    content:"Gifco, headquartered in Bengaluru, provides top-notch Fuel Filters in various specifications. With a stellar reputation in the market, we're recognized as leading manufacturers, suppliers, and exporters of Fuel Filters. Our machines are widely utilized for assessing filtering efficiency. Manufactured in compliance with ISI guidelines, our Fuel Filters ensure high quality and long-lasting hassle-free performance. Their automatic function and user-friendly design contribute to their increasing demand, while their sturdy structure enables them to handle heavy loads. As dependable Filter manufacturers, suppliers, and exporters, we're committed to offering the perfect solution for your industrial needs, tailored to satisfy your requirements effectively. Don't hesitate, send us your inquiries now.",
    features : [
      'Smooth performance',
      'Long running life',
      'Durable construction',
      'Smooth operation',
      'Automatic function',
    ],

    specifications : [
      'The specifications are  not fixed for the product and  we provide what our clients ask for.',
    ],

  },
  
  {
    appId: 5,
    appName: 'Zomato',
    imageUrl:
      'https://assets.ccbp.in/frontend/react-js/app-store/food-zomato.png',
    category: 'FOOD',
    imageUrl:""
  },
  
]

// Write your code here
const FuelFilterPageStore = () => {
  const [activeTabId, setActiveTabId] = useState(tabsList[0].tabId);
  const [searchInput, setSearchInput] = useState('');
  

  const getFilteredProjects = () => {
    const filterdata = appsList.filter(
      (eachdetails) => eachdetails.category === activeTabId
    );
    return filterdata;
  };

  const onchangestatus = (tabId) => {
    setActiveTabId(tabId);
  };

  const getinputdetails = (event) => {
    setSearchInput(event.target.value);
  };

  const fliterdataproject = getFilteredProjects();
  const searchresult = fliterdataproject.filter((eachfilterdata) =>
    eachfilterdata.appName.includes(searchInput)
  );

  return (
    <div className="appcontainer">
      <div className="cardcontainer">
        <div className="upcontainer">
          {/* <div className="search-input-container">
            <input
              type="search"
              className="search-input"
              placeholder="Search"
              onChange={getinputdetails}
            />
            <img
              src="https://assets.ccbp.in/frontend/react-js/app-store/app-store-search-img.png "
              alt="search icon"
              className="search_icon"
            />
          </div> */}
        </div>
        <ul className="tabitemcontainer">
          {tabsList.map((each) => (
            <TabFirst
              tabname={each}
              key={each.tabId}
              onchangestatus={onchangestatus}
              isActive={activeTabId === each.tabId}
            />
          ))}
        </ul>
        <ul className="appcontainer">
          {searchresult.map((each) => (
            <PageDetails Appitem={each} key={each.appId} />
          ))}
        </ul>
      </div>
    </div>
  );
};

export default FuelFilterPageStore;
